import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { getUmiPackage } from "../utils/getUmiPackage";
import { getGlobalShareConfigValueByKey } from "../utils/globalShareConfig";
import { useEffect } from "react";
export var useHistoryListener = function useHistoryListener(baseRoute) {
  var isTabsMode = getGlobalShareConfigValueByKey("tabsMode");
  var getListener = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var umiModules;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUmiPackage();
          case 2:
            umiModules = _context.sent;
            if (umiModules) {
              _context.next = 5;
              break;
            }
            throw new Error("can't find umi package");
          case 5:
            return _context.abrupt("return", umiModules.history);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getListener() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    var unListen = null;
    getListener().then(function (history) {
      unListen = history.listen(function (_ref2) {
        var location = _ref2.location,
          action = _ref2.action;
        if (!isTabsMode) {
          window.microApp.setGlobalData({
            "@@childPathnameChanged": {
              pathname: baseRoute + location.pathname,
              action: action
            }
          });
        }
      });
    });
    return function () {
      var _unListen;
      return (_unListen = unListen) === null || _unListen === void 0 ? void 0 : _unListen();
    };
  }, []);
};